import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_COUNTER_OFFERS_API_URL || process.env.REACT_APP_API_NOTIFICATION_URL ||
    (process.env.NODE_ENV === "production"
      ? "https://backend-notification.taximundo.com"
      : "https://backend-notification.andresdev.tech"),
  timeout: 15000,
});

export const managedOffersRequest = async (token, method, path, key) => {
  const response = await api.request({
    method,
    url: `/api/v1/counter-offers/${path}`,
    headers: {
      Authorization: `Bearer ${token}`,
      "X-Counter-Offers-Protocol": "1",
      ...(key ? { "Idempotency-Key": key } : {}),
    },
  });
  return response.data.data;
};

export const normalizeOffers = (snapshot, now) =>
  Object.values(snapshot?.offers || {})
    .filter((offer) => offer.status === "ACTIVE" && Number(offer.expiresAt) > now)
    .sort((a, b) => a.pickupEtaDurationSeconds - b.pickupEtaDurationSeconds);

export const matchesAssignment = (booking, assignment) => Boolean(
  booking && assignment && assignment.bookingKind === "BUSINESS" &&
  booking.uuid === assignment.bookingId &&
  Number(booking.idDriver) === Number(assignment.driverId) &&
  Number(booking.counterBooking) === Number(assignment.counterBooking) &&
  booking.counterOffersAssignmentId === assignment.assignmentId
);
